import { getItem } from './localStorageControl';

export const getBasePathByRole = () => {
    const role = String(getItem('role') || '').toUpperCase();

    if (role === 'ADMIN') return '/admin';
    if (role === 'TEAMLEAD') return '/teamlead';

    // EMPLOYEE + INTERN
    return '/employee';
};
